/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   LandingPageSection Component
 */

import { cn } from '@zcode-ui/shadz-ui'
import React from 'react'

export interface LandingPageSectionProps {
  backgroundColor?: string
  children?: React.ReactNode
  className?: string
  hideOverflow?: boolean
}
export const LandingPageSection = ({
  backgroundColor,
  children,
  className,
  hideOverflow,
}: LandingPageSectionProps) => (
  <div
    className={cn(
      'mx-auto',
      'my-0',
      'bg-gray-0',
      'max-[767px]:max-w-full',
      className,
      hideOverflow && 'overflow-hidden'
    )}
    style={{ background: backgroundColor }}
  >
    <div
      className={cn(
        'max-w-[1100px]',
        'mx-auto',
        'my-0',
        'max-[1180px]:w-full',
        'max-[1180px]:max-w-full',
        'max-[1180px]:px-10',
        'max-[1180px]:py-0',
        'max-[767px]:px-5',
        'max-[767px]:py-0'
      )}
    >
      {children}
    </div>
  </div>
)
